import { IElementTypeEditInfo } from './../models/index'

export const hotspotEditInfo = {
    editExcludeFields: []
}